import script from "./grnhomeForm.vue?vue&type=script&setup=true&lang=js"
export * from "./grnhomeForm.vue?vue&type=script&setup=true&lang=js"

import "./grnhomeForm.vue?vue&type=style&index=0&id=066447bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-066447bc"]])

export default __exports__